const COLORS = [
    '#615DEC',
    '#568CEB',
    '#56C7EB',
    '#56EBD0',
    '#56EB77',
    '#0693E3',
    '#ABB8C3',
    '#EB144C',
    '#F78DA7',
    '#9900EF',
];

export default COLORS;
